// Route pattern for a car model page under /bilguiden. Shared by BilGuideRouter and the server's prefetch route.
export const bilModellPath = 'bilmodell/:carSlug';
